{
  "srTitle": "アンチ・ヒューマン・サファリ・プロジェクト — ウクライナ・ヘルソンの市民をドローンから守る",
  "logoAlt": "アンチ・ヒューマン・サファリ・プロジェクトのロゴ",
  "intro": "私たちはウクライナ・ヘルソンのボランティア、緊急サービス、重要インフラの作業員に、小型ドローンの攻撃から身を守るための防護装備を提供しています。",
  "safari": "2024年夏以降、ヘルソンの市民はロシア軍によるビデオドローンを使った組織的な狩りの標的となっており、これは「ヒューマン・サファリ（Human Safari）」と呼ばれる恐怖キャンペーンです。",
  "unLink": "国連委員会、ヒューマン・サファリを戦争犯罪と認定",
  "donateNow": "今すぐ寄付する",
  "donateMonthly": "毎月寄付する",
  "otherWays": "その他の寄付方法",
  "instagram": "Instagram",
  "pastFundraisers": "過去の募金活動：",
  "fundraiser2025": "2025年の募金",
  "donateVia": "寄付方法：",
  "charityRef": "英国の慈善団体を通じて、記載事項：",
  "germanCharityRef": "ドイツの慈善団体を通じて、記載事項：",
  "copy": "コピー",
  "copied": "コピーしました！",
  "close": "閉じる",
  "viewMedia": "メディアを見る",
  "andrushenkoCredit": "オレクサンドル・アンドリュシェンコ（メディア「Vgoru」写真記者）",
  "fruitSellerDescription": "光ファイバー式ドローンに追われる果物売り",
  "khersonPoliceCredit": "@khersonpolice より",
  "firefighterDescription": "「ヒューマン・サファリ」の攻撃後、消防士が車両を消火する。奥には被害者が倒れている",
  "previousMedia": "前へ",
  "nextMedia": "次へ",
  "fpvDroneDescription": "「ヒューマン・サファリ」で出撃する FPV ドローン",
  "busAttackDescription": "公共交通機関を狙った数多くの FPV ドローン攻撃のひとつ",
  "notFoundTitle": "ページが見つかりません",
  "notFoundMessage": "このページは存在しません。移動されたか、リンクが誤っている可能性があります。",
  "backHome": "ホームへ戻る",
  "droneDetectorDescription": "ドローン探知機は、ドローンが近づくと警告してくれる小型の携帯機器です",
  "vestDescription": "軽量の防護ベストは、ドローン攻撃による負傷の程度を軽減できます"
}
